import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeadHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.00625C2 5.14375 5.13125 2 9 2H9.75C12.725 2 15.4125 4.16562 15.9156 7.00625C15.9875 7.4125 16.1281 7.80937 16.3875 8.13125L17.7 9.775C17.8938 10.0188 18 10.3188 18 10.6313C18 11.3875 17.3875 12 16.6313 12H16V14C16 15.1031 15.1031 16 14 16H12V17C12 17.5531 11.5531 18 11 18H5C4.44688 18 4 17.5531 4 17V14.7281C4 14.2062 3.78438 13.7125 3.46563 13.2969C2.51875 12.075 2 10.5656 2 9.00625ZM5.5 7.9125C5.5 8.41875 5.70312 8.90625 6.05937 9.26562L8.64375 11.85C8.8375 12.0438 9.15625 12.0438 9.35 11.85L11.9344 9.26562C12.2937 8.90625 12.4937 8.41875 12.4937 7.9125C12.4937 6.85625 11.6375 5.99688 10.5781 5.99688C10.0719 5.99688 9.58437 6.2 9.225 6.55625L8.99375 6.7875L8.7625 6.55625C8.40312 6.19688 7.91563 5.99688 7.40938 5.99688C6.35313 5.99688 5.49375 6.85312 5.49375 7.9125H5.5Z",
		fill: "#0D2976"
	})
});
export default SvgHeadHeart;
